<template>
  <VpLoaderContainer class="vp-py-12" loading v-if="loading" />
  <NotAllowed v-else-if="!isWhatsAppCloudEnabled" />

  <VpListLayout
    v-else
    :add-route="{
      name: 'whatsapp-template',
      params: { id: '+' },
    }"
    feature="WHATSAPP_BROADCAST_TEMPLATE"
    permission="upsert"
  >
    <VpList
      :per-page="10"
      :columns="columns"
      :endpoint="'whatsappCloudApiBroadcastTemplates'"
      class="vp-h-full"
      ref="list"
      :request-payload="{
        query: $options.whatsappCloudApiBroadcastTemplates,
      }"
      @rowClick="
        $router.push({
          name: 'whatsapp-template',
          params: {
            id: $event.id,
          },
        })
      "
      :cache="'whatsappCloudApiBroadcastTemplates'"
      :title="'Templates'"
      feature="WHATSAPP_BROADCAST"
    >
      <template #empty>
        <VpListEmpty :feature="feature" route="whatsapp-template" />
      </template>

      <template #type="{ item }">
        <div
          class="vp-text-xs vp-text-gray-900 vp-font-medium vp-flex vp-items-center vp-capitalize"
        >
          {{ item.template.format }}
        </div>
      </template>

      <template #language="{ item }">
        <div
          class="vp-text-xs vp-text-gray-900 vp-font-medium vp-flex vp-items-center"
        >
          {{ getLanguage(item.template.language) }}
        </div>
      </template>
    </VpList>
  </VpListLayout>
</template>

<script>
import whatsappCloudApi from "../whatsapp-broadcast/cloud-api/integration.gql";
import whatsappCloudApiBroadcastTemplates from "@/views/crm/marketing/whatsapp-template/collection.gql";
import NotAllowed from "../whatsapp-broadcast/_NotAllowed.vue";
import languageCodes from "@/assets/whatsappCloudApiLanguageCodes";

export default {
  whatsappCloudApiBroadcastTemplates,
  languageCodes,
  props: {
    feature: Object,
  },
  components: {
    NotAllowed,
  },
  data() {
    return {
      loading: false,
      isWhatsAppCloudEnabled: false,
      columns: [
        { name: "_index", label: "#", fix: true },
        { name: "name", type: "string" },
        { name: "type", type: "string" },
        { name: "language", type: "string" },
      ],
    };
  },

  created() {
    this.checkApi();
  },
  methods: {
    checkApi() {
      this.loading = true;
      return this.$query(whatsappCloudApi)
        .then(({ data: { integrationWhatsappCloudApi } }) => {
          if (
            integrationWhatsappCloudApi &&
            integrationWhatsappCloudApi.isEnabled &&
            integrationWhatsappCloudApi.businessAccountId
          ) {
            this.isWhatsAppCloudEnabled = true;
          }
        })
        .finally(() => (this.loading = false));
    },
    getLanguage(code) {
      const language = this.$options.languageCodes.find(
        (lang) => lang.value === code
      );
      return language.label;
    },
  },
};
</script>
